import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
} from "@mhome/ui";
import { Close, Air } from "@mui/icons-material";
import NumberBar from "../common/number-bar";
import { spacingToPx } from "../../lib/utils";

const FanSpeedDialog = ({
  open = false,
  onClose,
  speed,
  onChange,
  onSpeedUpdate,
  min = 0,
  max = 100,
  disabled = false,
}) => {
  const handleSpeedChange = (newValue) => {
    onChange(newValue);
  };

  const handleSpeedUpdate = (newValue) => {
    onSpeedUpdate(newValue);
  };

  return (
    <Dialog open={open} onClose={onClose} variant="pops" fullWidth>
      <DialogTitle className="flex items-center justify-between">
        <Typography className="text-lg font-semibold">Fan Speed</Typography>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {/* Fan Speed Slider */}
        <div
          className="flex items-center justify-center relative mx-auto"
          style={{
            gap: spacingToPx(2),
            paddingTop: spacingToPx(2),
            overflow: "visible",
            width: "400px",
            maxWidth: "100%",
          }}
        >
          {/* Small fan icon on left */}
          <Air
            style={{
              color: "hsl(var(--muted-foreground))",
              fontSize: "1.2rem",
              opacity: 0.7,
            }}
          />

          {/* NumberBar */}
          <NumberBar
            value={speed}
            onChange={handleSpeedChange}
            onValueUpdate={handleSpeedUpdate}
            min={min}
            max={max}
            suffix=""
            disabled={disabled}
            sliderProps={{
              opacity: disabled ? 0.5 : 1, // Only dim if mute functionality exists and is muted
              transition: "opacity 0.2s ease",
              "& .MuiSlider-thumb": {
                opacity: disabled ? 0.7 : 1,
              },
              "& .MuiSlider-track": {
                opacity: disabled ? 0.5 : 1,
              },
            }}
          />

          {/* Large fan icon on right */}
          <Air
            style={{
              color: "hsl(var(--primary))",
              fontSize: "1.8rem",
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FanSpeedDialog;
